import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { interior_view02ImageOptions } from './views/interior_view02'

class Xc47Fabric extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
    }


	handleFabricChange(newValue) {
		let configuration = { ...this.props.configuration };
		configuration.Fabric = newValue;
		configuration.FabricSeatOwnersCabin = newValue;  // Also update FabricSeatOwnersCabin

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}




    render() {
		let imageOptions = interior_view02ImageOptions;

        let image = <ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

					<h1><Trans defaults='SALOON' /></h1>

					
					<h2><Trans defaults='Fabrics' /></h2>
					<MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.Fabric.label} value={this.props.configuration.Fabric} onChange={this.handleFabricChange} />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47Fabric);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47Fabric.js